import { LOCALES } from "~constants";
import { Locale } from "~types/wardenclyffe";

export function isValidLocale(str: string): str is Locale {
    return Object.values(Locale).includes(str as unknown as Locale);
}
export { Locale };

export const LANGUAGE_MAP = {
    [LOCALES.default]: 1,
    [LOCALES.japan]: 2,
};
